"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OceanFarm = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Resources_1 = require("../../Resources");
const SpaceBonus_1 = require("../../SpaceBonus");
const TileType_1 = require("../../TileType");
const CardType_1 = require("./../CardType");
const Tags_1 = require("./../Tags");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class OceanFarm extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.OCEAN_FARM,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.BUILDING],
            cost: 15,
            productionBox: Units_1.Units.of({ plants: 1, heat: 1 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oceans(4)),
            metadata: {
                cardNumber: 'A21',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.heat(1).br;
                        pb.plants(1);
                    }).nbsp().tile(TileType_1.TileType.OCEAN_FARM, false, true);
                }),
                description: 'Requires 4 ocean tiles. Increase your heat production 1 step and increase your plant production 1 step. Place this tile on top of an existing ocean tile. The tile grants an ADJACENCY BONUS of 1 plant.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.HEAT, 1);
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        return new SelectSpace_1.SelectSpace('Select space for Ocean Farm', player.game.board.getOceansTiles(false), TileType_1.TileType.OCEAN_FARM, (space) => {
            const tile = {
                tileType: TileType_1.TileType.OCEAN_FARM,
                card: this.name,
                covers: space.tile,
            };
            player.game.addTile(player, space.spaceType, space, tile);
            space.adjacency = { bonus: [SpaceBonus_1.SpaceBonus.PLANT] };
            return undefined;
        });
    }
}
exports.OceanFarm = OceanFarm;
//# sourceMappingURL=OceanFarm.js.map